import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import CancelPurchase from '../../../forms/cancelPurchase/CancelPurchase';

const CancelPurchaseMobile = ({ ...props }) => {
  const { motiveId, product, profile, type, onData } = props;
  return (
    <Box>
      <CancelPurchase
        mobile
        motiveId={motiveId}
        product={product}
        profile={profile}
        type={type}
        onData={onData}
      />
    </Box>
  );
};

CancelPurchaseMobile.propTypes = {
  motiveId: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  type: PropTypes.string,
  onData: PropTypes.func,
};

export default CancelPurchaseMobile;
